import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useState } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-regal-dark border-b border-gray-800 sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <Link to="/" data-discover="true" className="flex items-center space-x-2" itemScope itemType="https://schema.org/Organization">
            <img src="/images/favicon.webp" alt="Regal Play" className="h-10 w-10 object-contain" itemprop="logo" />
            <span className="text-2xl font-bold text-white" itemprop="name">Regal Play</span>
          </Link>

          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" data-discover="true" className="text-gray-300 hover:text-regal-red transition-colors">
              Home
            </Link>
            <Link to="/guides" data-discover="true" className="text-gray-300 hover:text-regal-red transition-colors">
              Guides
            </Link>
            <Link to="/news" data-discover="true" className="text-gray-300 hover:text-regal-red transition-colors">
              News
            </Link>
            <Link to="/reviews" data-discover="true" className="text-gray-300 hover:text-regal-red transition-colors">
              Reviews
            </Link>
            <Link to="/slots" data-discover="true" className="text-gray-300 hover:text-regal-red transition-colors">
              Slots
            </Link>
          </nav>

          <button
            className="md:hidden text-gray-300 hover:text-regal-red"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-800">
            <nav className="flex flex-col space-y-4">
              <Link
                to="/"
                data-discover="true"
                className="text-gray-300 hover:text-regal-red transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <Link
                to="/guides"
                data-discover="true"
                className="text-gray-300 hover:text-regal-red transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Guides
              </Link>
              <Link
                to="/news"
                data-discover="true"
                className="text-gray-300 hover:text-regal-red transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                News
              </Link>
              <Link
                to="/reviews"
                data-discover="true"
                className="text-gray-300 hover:text-regal-red transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Reviews
              </Link>
              <Link
                to="/slots"
                data-discover="true"
                className="text-gray-300 hover:text-regal-red transition-colors"
                onClick={() => setIsMenuOpen(false)}
              >
                Slots
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;

